/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import type {
  Client,
  RequestConfig,
  ResponseErrorConfig,
} from "@/shared/api/axiosInstance";
import type {
  UseMutationOptions,
  UseMutationResult,
  QueryClient,
} from "@tanstack/react-query";
import type {
  PostApiV1SerieSerieidLangsMutationRequest,
  PostApiV1SerieSerieidLangsMutationResponse,
  PostApiV1SerieSerieidLangsPathParams,
  PostApiV1SerieSerieidLangs400,
  PostApiV1SerieSerieidLangs401,
  PostApiV1SerieSerieidLangs404,
  PostApiV1SerieSerieidLangs500,
} from "../../types/serieIdiomasController/PostApiV1SerieSerieidLangs.ts";
import { mutationOptions, useMutation } from "@tanstack/react-query";
import { postApiV1SerieSerieidLangs } from "../../clients/serieIdiomasController/postApiV1SerieSerieidLangs.ts";

export const postApiV1SerieSerieidLangsMutationKey = () =>
  [{ url: "/api/v1/serie/:serieId/langs" }] as const;

export type PostApiV1SerieSerieidLangsMutationKey = ReturnType<
  typeof postApiV1SerieSerieidLangsMutationKey
>;

export function postApiV1SerieSerieidLangsMutationOptions<TContext = unknown>(
  config: Partial<RequestConfig<PostApiV1SerieSerieidLangsMutationRequest>> & {
    client?: Client;
  } = {},
) {
  const mutationKey = postApiV1SerieSerieidLangsMutationKey();
  return mutationOptions<
    PostApiV1SerieSerieidLangsMutationResponse,
    ResponseErrorConfig<
      | PostApiV1SerieSerieidLangs400
      | PostApiV1SerieSerieidLangs401
      | PostApiV1SerieSerieidLangs404
      | PostApiV1SerieSerieidLangs500
    >,
    {
      serieId: PostApiV1SerieSerieidLangsPathParams["serieId"];
      data?: PostApiV1SerieSerieidLangsMutationRequest;
    },
    TContext
  >({
    mutationKey,
    mutationFn: async ({ serieId, data }) => {
      return postApiV1SerieSerieidLangs(serieId, data, config);
    },
  });
}

/**
 * @description Cria uma nova tradução (idioma) para a série. **(Requer Authorization para autenticação)**
 * @summary Criar idioma da série (Requer Authorization para autenticação)
 * {@link /api/v1/serie/:serieId/langs}
 */
export function usePostApiV1SerieSerieidLangs<TContext>(
  options: {
    mutation?: UseMutationOptions<
      PostApiV1SerieSerieidLangsMutationResponse,
      ResponseErrorConfig<
        | PostApiV1SerieSerieidLangs400
        | PostApiV1SerieSerieidLangs401
        | PostApiV1SerieSerieidLangs404
        | PostApiV1SerieSerieidLangs500
      >,
      {
        serieId: PostApiV1SerieSerieidLangsPathParams["serieId"];
        data?: PostApiV1SerieSerieidLangsMutationRequest;
      },
      TContext
    > & { client?: QueryClient };
    client?: Partial<
      RequestConfig<PostApiV1SerieSerieidLangsMutationRequest>
    > & { client?: Client };
  } = {},
) {
  const { mutation = {}, client: config = {} } = options ?? {};
  const { client: queryClient, ...mutationOptions } = mutation;
  const mutationKey =
    mutationOptions.mutationKey ?? postApiV1SerieSerieidLangsMutationKey();

  const baseOptions = postApiV1SerieSerieidLangsMutationOptions(
    config,
  ) as UseMutationOptions<
    PostApiV1SerieSerieidLangsMutationResponse,
    ResponseErrorConfig<
      | PostApiV1SerieSerieidLangs400
      | PostApiV1SerieSerieidLangs401
      | PostApiV1SerieSerieidLangs404
      | PostApiV1SerieSerieidLangs500
    >,
    {
      serieId: PostApiV1SerieSerieidLangsPathParams["serieId"];
      data?: PostApiV1SerieSerieidLangsMutationRequest;
    },
    TContext
  >;

  return useMutation<
    PostApiV1SerieSerieidLangsMutationResponse,
    ResponseErrorConfig<
      | PostApiV1SerieSerieidLangs400
      | PostApiV1SerieSerieidLangs401
      | PostApiV1SerieSerieidLangs404
      | PostApiV1SerieSerieidLangs500
    >,
    {
      serieId: PostApiV1SerieSerieidLangsPathParams["serieId"];
      data?: PostApiV1SerieSerieidLangsMutationRequest;
    },
    TContext
  >(
    {
      ...baseOptions,
      mutationKey,
      ...mutationOptions,
    },
    queryClient,
  ) as UseMutationResult<
    PostApiV1SerieSerieidLangsMutationResponse,
    ResponseErrorConfig<
      | PostApiV1SerieSerieidLangs400
      | PostApiV1SerieSerieidLangs401
      | PostApiV1SerieSerieidLangs404
      | PostApiV1SerieSerieidLangs500
    >,
    {
      serieId: PostApiV1SerieSerieidLangsPathParams["serieId"];
      data?: PostApiV1SerieSerieidLangsMutationRequest;
    },
    TContext
  >;
}
